import {Component, DoCheck, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SmartpowerLocation} from 'src/app/global/types';
import {MatSelectChange} from "@angular/material/select";


class SmartPowerLocationFormatted {
  agreementNumber: string = '';
  agreementName: string = '';
  accountNumber: string = '';
  unitNumber: string = '';
  accountName: string = '';
  address: string = '';
  dates: string[] = [];
}

@Component({
    selector: 'locations-table',
    templateUrl: './locations-table.component.html',
    styleUrls: ['./locations-table.component.scss'],
    standalone: false
})
export class LocationsTableComponent implements OnInit, DoCheck {

  @Input() data: SmartpowerLocation[] = []
  @Output() sendSelect = new EventEmitter<string[]>();
  dateColumns: string[] = [];
  formattedData: SmartPowerLocationFormatted[] = [];

  constructor() { }

  ngOnInit(): void {}

  ngDoCheck() {
    if (this.data.length > 0) {
      this.formatLocationData();
    }
  }

  onMetricSelect(event: MatSelectChange) {
    this.sendSelect.emit(event.value);
  }

  formatLocationData() {
    let dates = new Set(this.data.map(l => l.Period));
    this.dateColumns = Array.from(dates.values());

    let formattedSmartPowerLocationMap = new Map<string, SmartPowerLocationFormatted>();

    for (let d of this.data) {

      if (!formattedSmartPowerLocationMap.get(d.AccountNumber)) {
        let locationDataFormatted = new SmartPowerLocationFormatted();
        locationDataFormatted.agreementNumber = d.AgreementNumber;
        locationDataFormatted.agreementName = d.AgreementName;
        locationDataFormatted.accountNumber = d.AccountNumber;
        locationDataFormatted.accountName = d.AccountName;
        locationDataFormatted.address = d.Address;
        locationDataFormatted.unitNumber = d.UnitNumber;

        let dateValue = (!dates.has(d.Period)) ? '' : d.Value;
        locationDataFormatted.dates.push(dateValue);

        formattedSmartPowerLocationMap.set(d.AccountNumber, locationDataFormatted);
      } else {
        // @ts-ignore
        formattedSmartPowerLocationMap.get(d.AccountNumber).dates.push(d.Value);
      }
    }

    for (let key of formattedSmartPowerLocationMap.keys()) {
      // @ts-ignore
      let remainingDateValues = this.dateColumns.length - formattedSmartPowerLocationMap.get(key).dates.length;
      if (remainingDateValues > 0) {
        for (let i = 0; i < remainingDateValues; i++) {
          // @ts-ignore
          formattedSmartPowerLocationMap.get(key).dates.push("0");
        }
      }
    }


    this.formattedData = Array.from ( formattedSmartPowerLocationMap.values() );
  }
}
